import React from 'react'
import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Button } from 'elements'

const Appearing = styled.div`
  position: absolute;
  transition: left 0.5s, opacity 0.25s;
  top: ${themeGet('space.xxlarge')}px;

  ${({ editing }) => {
    if (editing) {
      return css`
        left: ${themeGet('space.xxlarge')}px;
        opacity: 1;
      `
    }
    return css`
      left: -400px;
      opacity: 0;
    `
  }};
`

const Disappearing = styled.div`
  position: absolute;
  transition: left 0.5s, opacity 0.25s;
  top: ${themeGet('space.xxlarge')}px;

  ${({ editing }) => {
    if (editing) {
      return css`
        left: 400px;
        opacity: 0;
      `
    }

    return css`
      left: ${themeGet('space.xxlarge')}px;
      opacity: 1;
    `
  }};
`

export default function AnimatedButtons({
  handleSave,
  currentTemplate,
  saving,
  setTemplateStep,
  editing,
  onNext,
  onClose,
  blank,
  closeAllOtherModals,
}) {
  //default and blank templates don't have id
  const hasTemplate = currentTemplate.id

  return (
    <>
      <Appearing editing={editing}>
        {hasTemplate ? (
          <Button
            onClick={handleSave}
            disabled={!currentTemplate?.id || blank}
            mr="medium"
            kind="secondary"
          >
            {saving ? 'Updating...' : 'Update Template'}
          </Button>
        ) : null}
        <Button
          kind={!hasTemplate ? 'secondary' : null}
          onClick={() => {
            closeAllOtherModals()
            setTemplateStep(1)
          }}
          mr="medium"
          disabled={blank}
        >
          Save as New
        </Button>
        <Button onClick={onNext} mr="medium" disabled={blank}>
          Use Once
        </Button>
      </Appearing>
      <Disappearing editing={editing}>
        <Button mr="medium" kind="secondary" onPress={onNext} disabled={blank}>
          Continue
        </Button>
        <Button onPress={onClose} mr="xxxlarge">
          Cancel
        </Button>
      </Disappearing>
    </>
  )
}
